export default "__VITE_ASSET__CgFC5FSy__"